

(function storageModuleDefinition() {

    'use strict';

    angular.module('Storage', []);

})();